const KEY = "finekraOpenBannerPromo";
const DISMISS_KEY = "finekraBannerPromoDismissUntil";

export function markOpenBannerPromoOnNextLoad() {
  try {
    sessionStorage.setItem(KEY, "1");
  } catch (_e) {
    /* ignore */
  }
}

/**
 * @returns {boolean} true once after login flag was set, then clears storage
 */
export function consumeOpenBannerPromo() {
  try {
    const v = sessionStorage.getItem(KEY);
    if (v === "1") {
      sessionStorage.removeItem(KEY);
      if (isBannerPromoDismissed()) return false;
      return true;
    }
  } catch (_e) {
    /* ignore */
  }
  return false;
}

export function dismissBannerPromoFor1Week() {
  try {
    const until = Date.now() + 7 * 24 * 60 * 60 * 1000;
    localStorage.setItem(DISMISS_KEY, until.toString());
  } catch (_e) {
    /* ignore */
  }
}

export function isBannerPromoDismissed() {
  try {
    const until = localStorage.getItem(DISMISS_KEY);
    if (!until) return false;
    if (Date.now() < Number(until)) return true;
    localStorage.removeItem(DISMISS_KEY);
  } catch (_e) {
    /* ignore */
  }
  return false;
}
